document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.brandSwiper');
  if (!sliders.length) return;

  sliders.forEach(function (slider) {
    // 1. Extract values with fallbacks
    const desktop = parseInt(slider.dataset.desktop) || 6;
    const tablet = parseInt(slider.dataset.tablet) || 4;
    const mobile = parseInt(slider.dataset.mobile) || 2;

    const autoplayEnabled = slider.dataset.autoplay === "true";
    const autoplaySpeed = (parseInt(slider.dataset.speed) || 4) * 1000;

    // 2. Initialize Swiper using the dynamic variables
    new Swiper(slider, {
      loop: true,
      speed: 700,
      slidesPerView: mobile, // Mobile base (e.g. 2)
      spaceBetween: 10,
      autoplay: autoplayEnabled
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: tablet, // Uses tablet dataset (e.g. 4)
          spaceBetween: 15
        },
        990: {
          slidesPerView: desktop, // Uses desktop dataset (e.g. 6)
          spaceBetween: 15
        }
      }
    });
  });
});
